import CheckmateApiClient from '../../../services/apiClient';
import { useQuery } from 'react-query';

const _apiClient = new CheckmateApiClient();

export const useGetCaseStatuses = () => {
    return useQuery({
        queryKey: ['get-case-statuses'],
        queryFn: async () => {
            const response = await _apiClient.getCaseStatusLookupData()

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error(`Failed to retrieve case statuses`);
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        staleTime: Infinity,
        cacheTime: Infinity,
    });
};
